import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import request from './request';
import { IBaseResponse, IResult } from './types/common';

export function getAntiPhishingCode() {
  const url = `${API2_HOST}/v3/private/user/member/get-anti-phishing-code`;
  return request.get<IBaseResponse<any>>(url, {
    useCache: true,
  });
}

export function addAntiPhishingCode(params: any) {
  const url = `${API2_HOST}/v3/private/user/member/add-anti-phishing-code`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

export function updateAntiPhishingCode(params: any) {
  const url = `${API2_HOST}/v3/private/user/member/update-anti-phishing-code`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
